const NotamachineSinglesStatic = () => {
    return (
      <>
        <div class="gallery_containerThree-static">  

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/5nv1RP7DRNoUYXodpyYuYU?si=5a6eb1efec1b4d62" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i.scdn.co/image/ab67616d00001e0213e5396fe4b85d93edfe0f4d" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>intro</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/423k3xZf4ClZsHZSzToQPK?si=0980122a117c42c2" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i.scdn.co/image/ab67616d00001e0213e5396fe4b85d93edfe0f4d" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>#1</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/0l0JPJxQH0UoK92iSsrOaz?si=6e10d53cfb574d35" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i.scdn.co/image/ab67616d00001e0213e5396fe4b85d93edfe0f4d" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>#2</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/2oR0boxnkHIpfDfQaplNfG?si=b1946de4f20e4e4c" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i.scdn.co/image/ab67616d00001e0213e5396fe4b85d93edfe0f4d" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>#3</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/0bJUzGTXYYgsdm7USjeOlF?si=7d8914cc59e643e8" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i.scdn.co/image/ab67616d00001e0213e5396fe4b85d93edfe0f4d" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>reveal</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/0OZdlw6Pq0t8BciQL5HdTO?si=6e0f305440944abe" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i.scdn.co/image/ab67616d00001e0213e5396fe4b85d93edfe0f4d" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>all my &#x3C;3</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/0BozRtRGfFJNQG1oLBTZoq?si=8d02b7e44ea049a6" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i.scdn.co/image/ab67616d00001e0213e5396fe4b85d93edfe0f4d" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>nostalgia's dream</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/1J1daOJI5SfjWHKNMfMixR?si=b58143c1f1b9486c" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i.scdn.co/image/ab67616d00001e0213e5396fe4b85d93edfe0f4d" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>headache, slow down</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/0l5Gw96s1GbhacGEEbpoLt?si=149860c8fdd44831" target="_blank" rel="noopener noreferrer">    
              <div class="overflow-hidden">
                <img src="https://i1.sndcdn.com/artworks-AnihoskiLWTh2mdu-DJIdeg-t500x500.png" width="100%" alt="" class="hover-zoom"/>
              </div>             
              <p class="gallery-text">
              <strong>dreaming</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/3mvgIjJmjNOupGW8QxjA1x?si=b723a4caccfd4bb8" target="_blank" rel="noopener noreferrer">    
              <div class="overflow-hidden">
                <img src="https://i1.sndcdn.com/artworks-AnihoskiLWTh2mdu-DJIdeg-t500x500.png" width="100%" alt="" class="hover-zoom"/>
              </div>             
              <p class="gallery-text">
              <strong>nobody</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/7uycHFQY57ASAt2go10Lpl?si=f8bee785f33444da" target="_blank" rel="noopener noreferrer">    
              <div class="overflow-hidden">
                <img src="https://i1.sndcdn.com/artworks-AnihoskiLWTh2mdu-DJIdeg-t500x500.png" width="100%" alt="" class="hover-zoom"/>
              </div>             
              <p class="gallery-text">
              <strong>reserved</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/2amTQs4Ieviga0NUkAyS8m?si=6c2aa0a4ff5b445e" target="_blank" rel="noopener noreferrer">    
              <div class="overflow-hidden">
                <img src="https://i1.sndcdn.com/artworks-AnihoskiLWTh2mdu-DJIdeg-t500x500.png" width="100%" alt="" class="hover-zoom"/>
              </div>             
              <p class="gallery-text">
              <strong>dancer Pt. 2 (feat. Kawaii Ry)</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/6wb8ZW3yV16zTApejRtIad?si=32336834e1ea4db9" target="_blank" rel="noopener noreferrer">    
              <div class="overflow-hidden">
                <img src="https://i1.sndcdn.com/artworks-AnihoskiLWTh2mdu-DJIdeg-t500x500.png" width="100%" alt="" class="hover-zoom"/>
              </div>             
              <p class="gallery-text">
              <strong>swimming</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/2r7bInu3cvHboB82Ze0BkA?si=7c581cc1fcff41ea" target="_blank" rel="noopener noreferrer">    
              <div class="overflow-hidden">
                <img src="https://i1.sndcdn.com/artworks-AnihoskiLWTh2mdu-DJIdeg-t500x500.png" width="100%" alt="" class="hover-zoom"/>
              </div>             
              <p class="gallery-text">
              <strong>dex's interlude (feat. Baredex)</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/5VZmNX2MMsCG3TXkG3IunL?si=519686df46354a69" target="_blank" rel="noopener noreferrer">    
              <div class="overflow-hidden">
                <img src="https://i1.sndcdn.com/artworks-AnihoskiLWTh2mdu-DJIdeg-t500x500.png" width="100%" alt="" class="hover-zoom"/>
              </div>             
              <p class="gallery-text">
              <strong>broken (feat. Kawaii Ry & rileylol)</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/3bynKma6hU4muH3nViv434?si=2237b9c50aeb4082" target="_blank" rel="noopener noreferrer">    
              <div class="overflow-hidden">
                <img src="https://i1.sndcdn.com/artworks-AnihoskiLWTh2mdu-DJIdeg-t500x500.png" width="100%" alt="" class="hover-zoom"/>
              </div>             
              <p class="gallery-text">
              <strong>eyes</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/3E2cK3yOtcPRCroX7FYRrn?si=53afacd7182648b4" target="_blank" rel="noopener noreferrer">    
              <div class="overflow-hidden">
                <img src="https://i1.sndcdn.com/artworks-AnihoskiLWTh2mdu-DJIdeg-t500x500.png" width="100%" alt="" class="hover-zoom"/>
              </div>             
              <p class="gallery-text">
              <strong>going</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/6z38pj1KBtdSCdJhMT5Hpw?si=6e6abc52e2794bac" target="_blank" rel="noopener noreferrer">    
              <div class="overflow-hidden">
                <img src="https://i1.sndcdn.com/artworks-AnihoskiLWTh2mdu-DJIdeg-t500x500.png" width="100%" alt="" class="hover-zoom"/>
              </div>             
              <p class="gallery-text">
              <strong>wake up</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/4bDJzPQRY7a1tZd2eGcXTw?si=7410ea1564714ec9" target="_blank" rel="noopener noreferrer">    
              <div class="overflow-hidden">
                <img src="https://i1.sndcdn.com/artworks-AnihoskiLWTh2mdu-DJIdeg-t500x500.png" width="100%" alt="" class="hover-zoom"/>
              </div>             
              <p class="gallery-text">
              <strong>morning</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/1QRHkG7FR8AX9oi1WR7uz3?si=47c5a7f7038e4c3a" target="_blank" rel="noopener noreferrer"> 
              <div class="overflow-hidden">
                <img src="https://i1.sndcdn.com/artworks-RH61p4zyUz6bA5Yw-0pGeYQ-t500x500.png" width="100%" alt="" class="hover-zoom"/>
              </div>                
              <p class="gallery-text">
              <strong>wave to shore and maybe they'll see you</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/1rVyEynCf0euqny2wjRRsT?si=22e25eaae1ae425f" target="_blank" rel="noopener noreferrer"> 
              <div class="overflow-hidden">
                <img src="https://i1.sndcdn.com/artworks-RH61p4zyUz6bA5Yw-0pGeYQ-t500x500.png" width="100%" alt="" class="hover-zoom"/>
              </div>                
              <p class="gallery-text">
              <strong>counting sheep</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/1cdcEmdP2rmf7azwYRlZnx?si=64983b27a7004df7" target="_blank" rel="noopener noreferrer"> 
              <div class="overflow-hidden">
                <img src="https://i1.sndcdn.com/artworks-RH61p4zyUz6bA5Yw-0pGeYQ-t500x500.png" width="100%" alt="" class="hover-zoom"/>
              </div>                
              <p class="gallery-text">
              <strong>stream of unconsciousness</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/4XwrbD4xpKOlres5EIvqUE?si=5cf1cf314e51417e" target="_blank" rel="noopener noreferrer"> 
              <div class="overflow-hidden">
                <img src="https://i1.sndcdn.com/artworks-RH61p4zyUz6bA5Yw-0pGeYQ-t500x500.png" width="100%" alt="" class="hover-zoom"/>
              </div>                
              <p class="gallery-text">
              <strong>notes on a wurli</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/6UbcyZ9FWDdnN5ExpWbrbq?si=3c5de78311e741ab" target="_blank" rel="noopener noreferrer"> 
              <div class="overflow-hidden">
                <img src="https://i1.sndcdn.com/artworks-RH61p4zyUz6bA5Yw-0pGeYQ-t500x500.png" width="100%" alt="" class="hover-zoom"/>
              </div>                
              <p class="gallery-text">
              <strong>deteriorate</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/2ENjkK6zhuhg0AYk9VJ12H?si=8de6883b4cdb45e5" target="_blank" rel="noopener noreferrer"> 
              <div class="overflow-hidden">
                <img src="https://i1.sndcdn.com/artworks-RH61p4zyUz6bA5Yw-0pGeYQ-t500x500.png" width="100%" alt="" class="hover-zoom"/>
              </div>                
              <p class="gallery-text">
              <strong>standby / and wait</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/5teiDAoXfvk01DfsLzTyNh?si=661e383ffa3e4ff6" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i.scdn.co/image/ab67616d00001e02e503f1aa754b23c993e3ab4a" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>parallax:</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/4SqTAwF0hf7l34udkx4ddp?si=e1e10becb29b446e" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i.scdn.co/image/ab67616d00001e02e503f1aa754b23c993e3ab4a" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>someday:</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/23IOnBpuPdZwntyINljAmS?si=f56a548771f54ba8" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i.scdn.co/image/ab67616d00001e02e503f1aa754b23c993e3ab4a" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>heart atk:</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/6PRTErX4k3YgEUEHPsXXvd?si=0d1636af56984afe" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i.scdn.co/image/ab67616d00001e02e503f1aa754b23c993e3ab4a" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>u got us:</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/1bL8uqxt4CtTk6A0au6GAX?si=1dc7c7e79ba9490f" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i.scdn.co/image/ab67616d00001e02e503f1aa754b23c993e3ab4a" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>lost in your eyessss:</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/5rFGxsBhT4TN99u0qoNDSN?si=3d5a498c923a4762" target="_blank" rel="noopener noreferrer">    
              <img src="https://i.scdn.co/image/ab67616d00001e02a7d33975f76d56a20163251b" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>fall</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/2fHsutbgrRGYSrFJVZZX6V?si=6b85741ea955425a" target="_blank" rel="noopener noreferrer">    
              <img src="https://i.scdn.co/image/ab67616d00001e02b4005588bc8f2d1de3f3eb4d" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>pt i</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/25UlkXqFHvwxPeGZhokNa8?si=a0ac72e67a304531" target="_blank" rel="noopener noreferrer">    
              <img src="https://i.scdn.co/image/ab67616d00001e02b4005588bc8f2d1de3f3eb4d" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>birdsongs</strong><br/>
                (feat. Kawaii Ry)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/3V50ZTDDET86sQo9gKwFfF?si=cf0bd3d342094f3c" target="_blank" rel="noopener noreferrer">    
              <img src="https://i.scdn.co/image/ab67616d00001e02b4005588bc8f2d1de3f3eb4d" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>enjoy yourself</strong><br/>
                (feat. Kawaii Ry & Lugosi)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/3D22ziOgyplsGFDLkUFR7H?si=d97c4e405064475d" target="_blank" rel="noopener noreferrer">    
              <img src="https://i.scdn.co/image/ab67616d00001e02b4005588bc8f2d1de3f3eb4d" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>pt ii</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/6f0wOhCOhyz8S7pR5HiZGj?si=b6f34406a5b741d2" target="_blank" rel="noopener noreferrer">    
              <img src="https://i.scdn.co/image/ab67616d00001e02b4005588bc8f2d1de3f3eb4d" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>faded</strong><br/>
                (feat. Lugosi)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/6f0wOhCOhyz8S7pR5HiZGj?si=b6f34406a5b741d2" target="_blank" rel="noopener noreferrer">    
              <img src="https://i.scdn.co/image/ab67616d0000b273baf9695f125261f9cecc3f90" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>dont4getme</strong><br/>
                (feat. Kawaii Ry)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/6dRGdQJTzygvMZj3mAugrN?si=bbb74617f06c4e92" target="_blank" rel="noopener noreferrer">    
              <img src="https://i.scdn.co/image/ab67616d0000b27399e29f3e25ade7308f057c76" width="100%" alt=""/><br/>
              <p class="gallery-text">
              <strong>towards the light:</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/47uiAgSgJS3NNrFJFCiuUy?si=85c4799a0cb84028" target="_blank" rel="noopener noreferrer">    
              <img src="https://i.scdn.co/image/ab67616d0000b27399e29f3e25ade7308f057c76" width="100%" alt=""/><br/>
              <p class="gallery-text">
              <strong>just met you:</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/3mgd2r2C5Q2xezD6vuJP55?si=ce6e4fe347744d6c" target="_blank" rel="noopener noreferrer">    
              <img src="https://i.scdn.co/image/ab67616d0000b27399e29f3e25ade7308f057c76" width="100%" alt=""/><br/>
              <p class="gallery-text">
              <strong>talking to a ghost:</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/3PYgVWQZQNaUdOqPwv4sdF?si=16a06727131d4f84" target="_blank" rel="noopener noreferrer">    
              <img src="https://i.scdn.co/image/ab67616d0000b27399e29f3e25ade7308f057c76" width="100%" alt=""/><br/>
              <p class="gallery-text">
              <strong>elevator interlude:</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/54il6aeYrp6u4rfwNICLQL?si=93b18be55ed54fd5" target="_blank" rel="noopener noreferrer">    
              <img src="https://i.scdn.co/image/ab67616d0000b27399e29f3e25ade7308f057c76" width="100%" alt=""/><br/>
              <p class="gallery-text">
              <strong>relax:</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/5IbSlBgXWVTg4iDX8Ektmn?si=3ed46c4be3fc4f24" target="_blank" rel="noopener noreferrer">    
              <img src="https://i.scdn.co/image/ab67616d0000b27397d3098af36de69b81c9f7ac" width="100%" alt=""/><br/>
              <p class="gallery-text">
              <strong>DANCER (feat. Kawaii Ry)</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/4slOcnhSNAnJrxR1fAdK7c?si=e6869695664b464b" target="_blank" rel="noopener noreferrer">    
              <img src="https://i.scdn.co/image/ab67616d0000b27334a304d134ddf7a087b707ca" width="100%" alt=""/><br/>
              <p class="gallery-text">
              <strong>fomo</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/5VmFIGc0luHSWgcPrBQLeR?si=b3da5ec0f5a94f56" target="_blank" rel="noopener noreferrer">    
              <img src="https://i.scdn.co/image/ab67616d0000b27334a304d134ddf7a087b707ca" width="100%" alt=""/><br/>
              <p class="gallery-text">
              <strong>ghost emoji</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/1O7rAzWwnPjsKmmxos2NdB?si=55f1244dffc24988" target="_blank" rel="noopener noreferrer">    
              <img src="https://i.scdn.co/image/ab67616d0000b27334a304d134ddf7a087b707ca" width="100%" alt=""/><br/>
              <p class="gallery-text">
              <strong>hyperactivity (seven seconds)</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/1NrpZsAOiCfVqhLlsPggFF?si=3f5f52023e2d4f57" target="_blank" rel="noopener noreferrer">    
              <img src="https://i.scdn.co/image/ab67616d0000b27334a304d134ddf7a087b707ca" width="100%" alt=""/><br/>
              <p class="gallery-text">
              <strong>here for a good time</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/5RHOncgKkpK1cPmqVRxw4m?si=48ec102269f14b11" target="_blank" rel="noopener noreferrer">    
              <img src="https://i.scdn.co/image/ab67616d0000b27334a304d134ddf7a087b707ca" width="100%" alt=""/><br/>
              <p class="gallery-text">
              <strong>irl</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/6AGKtRwDjjj1nonfVpZyTb?si=ba1d82605d1a4dc9" target="_blank" rel="noopener noreferrer">    
              <img src="https://i.scdn.co/image/ab67616d0000b27334a304d134ddf7a087b707ca" width="100%" alt=""/><br/>
              <p class="gallery-text">
              <strong>artificial</strong><br/>
              </p>
            </a>
          </div>

        </div>
      </>
    );
  };
  export default NotamachineSinglesStatic;